import {customElement, bindable, autoinject, containerless} from "aurelia-framework";
//import {LoggingService} from "../../../services/logging-service"
import { IColumnState } from "../../../services/sort-column-service";
import {computedFrom} from "aurelia-framework";
import "./sort-column-buttons.css";

@containerless
@autoinject
@customElement('sort-column-buttons')
export class SortColumnButtons {
    @bindable columnState: IColumnState; 
    @bindable columnName: string; 

    constructor(/*private loggingService: LoggingService*/) {

    }

    @computedFrom("columnState")
    get descending() {
        return this.columnState ? this.columnState.descending : false;
    }

    @computedFrom("columnState", "columnName")
    get isMe() {
        return this.columnState && (this.columnState.columnName === this.columnName);
    }
}